module.exports = __webpack_public_path__ + "static/8-4e3b337f16b2aedf83d98583145f38c4.jpg";